import axios from 'axios';
import { postRequest, getRequest, BASE_API_URL } from '../request/request.service';
import {
  SupportTicketRequest,
  PublicSupportTicketRequest,
  SupportTicketResponse,
  VerificationResponse,
} from './support-service.types';

const publicHttpClient = axios.create({
  baseURL: BASE_API_URL,
  withCredentials: false,
  timeout: 30000,
});

export const createSupportTicket = async (
  data: SupportTicketRequest
): Promise<SupportTicketResponse> => {
  const formData = new FormData();

  formData.append('support_ticket[subject]', data.support_ticket.subject);
  formData.append('support_ticket[message]', data.support_ticket.message);

  if (data.support_ticket.tags && data.support_ticket.tags.length > 0) {
    data.support_ticket.tags.forEach((tag) => {
      formData.append('support_ticket[tags][]', tag);
    });
  }

  if (data.attachments && data.attachments.length > 0) {
    data.attachments.forEach((file) => {
      formData.append('attachments[]', file);
    });
  }

  return postRequest<SupportTicketResponse>('/support_tickets', {
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const createPublicSupportTicket = async (
  data: PublicSupportTicketRequest
): Promise<SupportTicketResponse> => {
  const formData = new FormData();

  formData.append('support_ticket[subject]', data.support_ticket.subject);
  formData.append('support_ticket[message]', data.support_ticket.message);
  formData.append('support_ticket[requester_name]', data.support_ticket.requester_name);
  formData.append('support_ticket[requester_email]', data.support_ticket.requester_email);

  if (data.support_ticket.tags && data.support_ticket.tags.length > 0) {
    data.support_ticket.tags.forEach((tag) => {
      formData.append('support_ticket[tags][]', tag);
    });
  }

  if (data.attachments && data.attachments.length > 0) {
    data.attachments.forEach((file) => {
      formData.append('attachments[]', file);
    });
  }

  const response = await publicHttpClient.post<SupportTicketResponse>(
    '/support_tickets',
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return response.data;
};

export const verifySupportTicket = async (token: string): Promise<VerificationResponse> => {
  return getRequest<VerificationResponse>(`/support_tickets/verify/${token}`);
};
